import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import Container from "@mui/material/Container";
const useStyles = makeStyles({
  image: {
    maxWidth: "100%",
  },
});

export default ({ data }) => {
  const classes = useStyles();

  if (!data.src) {
    return null;
  }

  if (data.link) {
    return (
      <Container>
        <a href={data.link} target={data.openInNewWindow ? "_blank" : "_self"}>
          <img className={classes.image} src={data.src} />
        </a>
      </Container>
    );
  } else {
    return (
      <Container>
        <img className={classes.image} src={data.src} />
      </Container>
    );
  }
};
